import { Account } from 'ykd-base/account'
import { SchoolInfo } from '@/model/account/bmUser'
import request from 'ykd-base/request'
export async function querySchool() {
  const result = await request<SchoolInfo[]>({
    method: 'POST',
    biz: 'bmatch',
    url: '/resume/school/query',
    data: {}
  })
  return result && result.data
}

/**
 * 修改用户手机号
 * @param mobile
 */
export async function changeMobile({
  mobile,
  smsCode
}: {
  mobile: string
  smsCode: string
}) {
  const result = await request<Account>({
    method: 'POST',
    biz: 'ham',
    url: '/member/account/changemobile',
    data: {
      mobile,
      smsCode
    }
  })
  return result && result.isSuccess
}

export async function loginByUserName(userName: string, pwd: string) {
  const result = await request<any>({
    method: 'POST',
    biz: 'done',
    url: '/member/loginwithusername',
    data: {
      userName: userName,
      pwd: pwd
    }
  })
  return result
}


export async function logOut() {
  const result = await request<any>({
    method: 'POST',
    biz: 'done',
    url: '/member/logout',
  })
  return result
}

